'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp; /**
                    * Created by Administrator on 2016/7/29.
                    */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GoeasySelectField = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(GoeasySelectField, _Component);

  function GoeasySelectField() {
    (0, _classCallCheck3.default)(this, GoeasySelectField);

    var _this = (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(GoeasySelectField).call(this));

    _this.state = {
      firstInit: false
    };
    return _this;
  }

  (0, _createClass3.default)(GoeasySelectField, [{
    key: 'onSelectChange',
    value: function onSelectChange(event, oldValue) {
      var _props = this.props;
      var onChange = _props.onChange;
      var afterInit = _props.afterInit;
      var firstInit = this.state.firstInit;

      if (!firstInit) {
        if (afterInit) {
          afterInit(event.target.value);
        }
        this.setState({
          firstInit: true
        });
      }
      if (onChange && event.target.value !== oldValue) {
        onChange(event.target.value);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var styles = require('./GoeasyInputField.scss');
      var _props2 = this.props;
      var label = _props2.label;
      var inputType = _props2.inputType;
      var labelStyle = _props2.labelStyle;
      var value = _props2.value;
      var disabled = _props2.disabled;
      var formProps = _props2.formProps;

      var component = '';
      if (disabled) {
        component = _react2.default.createElement(
          'div',
          { className: styles.field },
          formProps.value
        );
      } else {
        component = _react2.default.createElement(
          'select',
          (0, _extends3.default)({ ref: 'field', type: inputType ? inputType : 'text', className: styles.field }, formProps, {
            value: value, onChange: function onChange(event) {
              return _this2.onSelectChange(event, value);
            } }),
          this.props.children
        );
      }
      return _react2.default.createElement(
        'div',
        { className: styles.component },
        _react2.default.createElement(
          'div',
          { className: styles.label,
            style: labelStyle ? labelStyle : { fontSize: '14px' } },
          label ? label : ''
        ),
        _react2.default.createElement(
          'div',
          { className: styles.input },
          component
        ),
        _react2.default.createElement('div', { className: 'clear' }),
        formProps.error && formProps.touched && _react2.default.createElement(
          'div',
          { className: styles.textDanger },
          formProps.error
        )
      );
    }
  }]);
  return GoeasySelectField;
}(_react.Component), _class.propTypes = {
  label: _react.PropTypes.string,
  inputType: _react.PropTypes.string,
  inputPlaceholder: _react.PropTypes.string,
  labelStyle: _react.PropTypes.object,
  fieldStyle: _react.PropTypes.object,
  inputStyle: _react.PropTypes.object,
  value: _react.PropTypes.string,
  onChange: _react.PropTypes.func,
  formProps: _react.PropTypes.object,
  disabled: _react.PropTypes.bool,
  children: _react.PropTypes.array,
  afterInit: _react.PropTypes.func
}, _temp);
exports.default = GoeasySelectField;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/GoeasyInputField/GoeasySelectField.js
 ** module id = 601
 ** module chunks = 0
 **/